import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  listPaymentMethodManager,
  detailPaymentMethodManager,
  resetDetailPaymentMethodManager,
  resetUpdatePaymentMethodManager,
  updatePaymentMethodManager,
  createPaymentMethodManager,
} from "store/actions";
import * as yup from "yup";
import { emailPrefix, userModeList, userRecordStatus } from "./utils";

const DetailUser = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    mode,
    employeeList,
    userRoleList,
    userPaymentMethodManager,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["paymentMethodManager"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.PaymentMethodManager);
  const {
    loadingDetail,
    errorDetail,
    detail: VATDetail,
    create: userCreate,
    loadingUpdate,
    errorUpdate,
    errorCreate,
    update: userUpdate,
  } = userManagement;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const initControlFields = {
    display: {
      htttoan: false,
      btn_save: false,
    },
  };

  const [controlFields, setControlFields] = useState(initControlFields);

  const schema = yup.object().shape({
    htttoan: yup.string(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      htttoan: "",
    },
  });
  useEffect(() => {
    if (errorCreate) {
      if (errorCreate.code && errorCreate.code === 422) {
        addToast(
          "Phương thức thanh toán đã bị trùng, vui lòng thử lại phương thức khác",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetUpdatePaymentMethodManager());
      }
    }
  }, [errorCreate]);
  useEffect(() => {
    if (!isOpenModal) {
      dispatch(resetDetailPaymentMethodManager());
      setIsDetail(false);
      setControlFields(initControlFields);
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.userId && !isDetail) {
        dispatch(detailPaymentMethodManager(dataDetail.userId));
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (VATDetail && VATDetail.success && !isDetail) {
        let username = "";
        const defaultValues = {
          user_profile_id: undefined,
          user_role: [],
        };
        reset({});
        const dataReset = {};

        dataReset["htttoan"] = VATDetail.htttoan;
        switch (mode) {
          case userModeList.VIEW_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            if (VATDetail) {
              setValue("htttoan", VATDetail.htttoan);
            }

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                record_status: true,
                user_role: true,
              },
            });
            break;
          case userModeList.EDIT_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            if (VATDetail.usprofile) {
              setValue("htttoan", VATDetail.htttoan);
            }

            if (VATDetail.user_profile) {
              setDataUserProfile({
                value: VATDetail.user_profile.id,
                label: VATDetail.user_profile.code,
              });
            }

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                record_status: true,
                user_role: true,
                btn_save: true,
              },
            });
            break;
          default:
            break;
        }
        setIsDetail(true);
      } else {
        if (Object.keys(dataDetail).length === 0) {
          setControlFields({
            display: {
              ...initControlFields.display,
              user_profile_id: true,
              user_profile_phone: true,
              user_profile_name: true,
              user_profile_email: true,
              user_login: true,
              user_role: true,
              btn_save: true,
            },
          });
          setValue("htttoan", "");
        }
      }
    }
  }, [isDetail, isOpenModal, mode, reset, setValue, VATDetail]);

  // Action Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (userUpdate && userUpdate.success) {
        addToast(t("form.submit.update.user.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(
          listPaymentMethodManager({
            ...(userPaymentMethodManager && userPaymentMethodManager.params),
            page: 1,
            sizePerPage: 10,
          })
        );
        dispatch(resetUpdatePaymentMethodManager());
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, isOpenModal, mode, t, userUpdate]);

  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail && errorDetail.message) {
        addToast(errorDetail.message, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDetailPaymentMethodManager());
      }

      if (errorUpdate) {
        if (errorUpdate.code && errorUpdate.code === 422) {
          addToast(
            "Phương thức thanh toán đã bị trùng, vui lòng thử lại phương thức khác",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        if (
          errorUpdate &&
          errorUpdate.fields &&
          errorUpdate.fields.length > 0
        ) {
          errorUpdate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "usprofile_id":
                fieldName = "user_profile_id";
                break;
              case "username":
                fieldName = "user_login";
                break;
              case "roles":
                fieldName = "user_role";
                break;
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, { type: "manual", message: item.message });
          });
        }
        dispatch(resetUpdatePaymentMethodManager());
        if (errorUpdate.code !== 422) {
          toggleModal(mode);
        }
      }
    }
  }, [
    addToast,
    dispatch,
    errorDetail,
    errorUpdate,
    isOpenModal,
    mode,
    setError,
    toggleModal,
  ]);

  const setDataUserProfile = data => {
    const userProfileId = data.value;
    const userProfile = employeeList.items.find(
      item => item.id === userProfileId
    );
    if (userProfile) {
      setValue("htttoan", userProfile.htttoan ? userProfile.htttoan : "");
    }
  };

  const onSubmit = values => {
    switch (mode) {
      case userModeList.EDIT_USER_DETAIL:
        if (Object.keys(dataDetail).length === 0) {
          dispatch(
            createPaymentMethodManager({
              htttoan: values.htttoan,
            })
          );
        } else {
          dispatch(
            updatePaymentMethodManager(VATDetail.id, {
              htttoan: values.htttoan,
            })
          );
        }
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(
        listPaymentMethodManager({
          ...(userPaymentMethodManager && userPaymentMethodManager.params),
          page: 1,
          sizePerPage: 10,
        })
      );
      dispatch(resetUpdatePaymentMethodManager());
      toggleModal(mode);
    }
  }, [addToast, dispatch, t, userCreate]);
  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggleModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleModal}>
          {mode === userModeList.VIEW_USER_DETAIL && `${t("title.detail")}`}
          {mode === userModeList.EDIT_USER_DETAIL &&
          Object.keys(dataDetail).length === 0
            ? `${t("title.create")}`
            : controlFields.display.btn_save && `${t("title.edit")}`}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="8"
              countButton="2"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Form>
                <Row className="row-cols-1 row-cols-md-2">
                  {controlFields.display.user_profile_phone && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="htttoan">{t("table.htttoan")}</Label>
                        <input
                          type="text"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          className="form-control"
                          {...register("htttoan")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={loadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.save")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailUser.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  employeeList: PropTypes.object,
  userRoleList: PropTypes.object,
  userPaymentMethodManager: PropTypes.object,
};

DetailUser.defaultProps = {
  userPaymentMethodManager: {},
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  employeeList: {},
  userRoleList: {},
};

export default DetailUser;
